import { ReactElement, useContext, useEffect, useMemo, useState } from 'react';
import { useRouter } from 'next/router';
import { Let2OffsetRenewalUiMode } from '@havenengineering/module-shared-owners-library/dist/enums/let2offsetRenewalUiMode';
import { useAuthContext } from '@havenengineering/module-shared-owners-ui';

import { LettingsContext } from '../contexts/lettings';
import { fetchWrapper, withApiBaseUrl } from '../helpers/fetch';
import { parseLet2offsetRenewalUiMode } from '../helpers/lettingMarketing';
import { RestrictedLayout } from '../layouts/RestrictedLayout';
import { LettingConfigEntry } from '../types/lettingConfig';

type RenewalsBlock = {
  children: ReactElement;
};

export const RenewalsBlock = ({ children }: RenewalsBlock) => {
  const router = useRouter();
  const { lettingAccount, lettingSummary } = useContext(LettingsContext);
  const { loggedInUser } = useAuthContext();
  const [lettingConfig, setLettingConfig] = useState<
    LettingConfigEntry[] | null
  >(null);

  useEffect(() => {
    const fetchLettingConfig = async () => {
      if (loggedInUser) {
        try {
          const config = await fetchWrapper(
            withApiBaseUrl(
              '/letting/letting-config?name=let2offsetRenewalUiMode'
            ),
            {
              method: 'GET',
              credentials: 'include',
            }
          );
          setLettingConfig(config);
        } catch (error) {
          // error while fetching letting config
        }
      }
    };

    fetchLettingConfig();
  }, [loggedInUser]);

  const renewalMode = useMemo(
    () => parseLet2offsetRenewalUiMode(lettingConfig),
    [lettingConfig]
  );

  const showRestrictedLayout =
    loggedInUser &&
    renewalMode === Let2OffsetRenewalUiMode.FORCE_RENEWAL &&
    lettingSummary?.let2Own &&
    lettingAccount?.readyForRenewal;

  if (!showRestrictedLayout) {
    return children;
  }

  if (
    router.pathname === '/renewals' ||
    router.pathname === '/bookings' ||
    router.pathname.startsWith('/let2offset-renewal') ||
    router.pathname === '/finance/partial-payment' ||
    router.pathname.includes('direct-debit')
  ) {
    return <RestrictedLayout>{children}</RestrictedLayout>;
  }

  router.push('/renewals');
  return null;
};
